const constants = {
  wordsInPassword: 2,
};

export default constants;
